import { useState } from "react";
import { API_URL } from "../api/client";
import Button from "./Button";

const initialForm = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

export default function ContactForm() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  function handleChange(event) {
    setForm({ ...form, [event.target.name]: event.target.value });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setStatus({ type: "", message: "" });

    if (!form.name || !form.email || !form.subject || !form.message) {
      setStatus({ type: "error", message: "Please complete all fields." });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Something went wrong.");
      setForm(initialForm);
      setStatus({ type: "success", message: data.message });
    } catch (error) {
      setStatus({ type: "error", message: error.message });
    } finally {
      setLoading(false);
    }
  }

  return (
    <form className="glass-card form-card" onSubmit={handleSubmit}>
      <div className="form-grid">
        <label>
          <span>Name</span>
          <input name="name" value={form.name} onChange={handleChange} placeholder="Your name" />
        </label>
        <label>
          <span>Email</span>
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
        </label>
      </div>
      <label>
        <span>Subject</span>
        <input name="subject" value={form.subject} onChange={handleChange} placeholder="Coaching or eBook question" />
      </label>
      <label>
        <span>Message</span>
        <textarea name="message" value={form.message} onChange={handleChange} rows="6" placeholder="Tell us how we can help" />
      </label>
      {status.message && <p className={`form-status ${status.type}`}>{status.message}</p>}
      <Button type="submit" disabled={loading}>{loading ? "Sending..." : "Send Message"}</Button>
    </form>
  );
}
